import { Component, OnInit } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ListMySprintsRequest, Sprint } from '../protogen/planning/service_pb';
import { SprintService } from '../sprint.service';

@Component({
  selector: 'app-mysprints',
  templateUrl: './mysprints.component.html',
  styleUrls: ['./mysprints.component.scss']
})
export class MysprintsComponent implements OnInit {
  dataLoaded: boolean = false;

  displayedColumns: string[] = ['name'];
  dataSource: MatTableDataSource<Sprint.AsObject> = new MatTableDataSource();

  constructor(private sprintService: SprintService) {
    this.fetchSprints();
  }

  ngOnInit(): void {
  }

  private async fetchSprints() {
    // TODO: Deal with pagination here?
    const req = new ListMySprintsRequest();
    const response = await this.sprintService.listMySprints(req);
    this.dataLoaded = true;

    // Sort manually here.
    let sprintList = response.sprintsList.slice(0).sort((a: Sprint.AsObject, b: Sprint.AsObject) => {
      // Sort by descending sprint id.
      return parseInt(b.id) - parseInt(a.id);
    });

    this.dataSource = new MatTableDataSource(sprintList);
  }

}
